import { nextTick, ref, useTemplateRef } from 'vue';
import $ from 'jquery';

const useRenderAnimatedItemHook = (elRef) => {
  const itemTemplateRef = useTemplateRef(elRef);

  const isItemRendered = ref(false);

  const renderItem = async (animated = true) => {
    if (animated) {
      await nextTick();

      if (itemTemplateRef.value) {
        /**
         * Used jQuery in order to call the 'slideDown' method.
         * The 'slideDown' will change the 'display' value (on init it is 'none' (ref. 'v-show='isItemRendered'' in template))
         * and display the matched element with a sliding motion.
         *
         * No need to change the 'isItemRendered' value in that case.
         */
        $(itemTemplateRef.value).slideDown();

        return;
      }
    }

    isItemRendered.value = true;
  };

  return [isItemRendered, renderItem];
};

export default useRenderAnimatedItemHook;
